import { useLocation } from "react-router-dom";
import InnerBannerWrapper from "./innerBannerWrapper";

function ViewPDF() {
  const location = useLocation();

  const AWSFilePath: string = location?.state?.AWSFilePath || "";

  return (
    <>
      <InnerBannerWrapper />

      <section className="cataloguesInner py-100">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-12 text-center mb-5">
              <h2 className="titleMain">VIEW CATALOGUES</h2>
              <p className="txt-gray">
                View the catalogues that help you open the world of
                sophistication, and discover the perfect engineering to make
                your vision a reality.
              </p>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 col-12">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="pdfViewer">
                    <object
                      data={AWSFilePath}
                      type="application/pdf"
                      width="100%"
                      height="786"
                    >
                      <iframe
                        title={Date.now().toString()}
                        src={AWSFilePath}
                        width="100%"
                        height="786"
                      >
                        <p>This browser does not support PDF!</p>
                      </iframe>
                    </object>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ViewPDF;
